function twoColumnImage() {
    $('.two-column-photo-block').each(function() {
        var $container = $(this);
        var $img = $(this).find('.img-container img');

        $container.css('min-height', $img.actual('height') + 'px');
    });
}

twoColumnImage();

$(window).on('resize', function() {
    twoColumnImage();
});

